var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('div',{staticClass:"tag",class:{active: _vm.isTagged(tag)},on:{"click":function($event){return _vm.toggle(tag)}}},[_vm._v("\n\t\t\t"+_vm._s(tag.tag)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }